(function($) {
$(document).ready(function() {

    // BLOG SLIDES
    if( $('.section-news-info .news-info-wrap').length > 0 ) {
        $('.section-news-info .news-info-wrap').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            arrows: true
        });
    }


    // SLIDE IMAGES
    let $imageSlider = $('.section-new-item .new-item-wrap');
    if( $imageSlider.length > 0 ) {
        let slideSpeed = $imageSlider.attr('data-speed') ? parseInt($imageSlider.attr('data-speed')) : 1;
        slideSpeed = slideSpeed * 1000;
        let slideAuto = $imageSlider.attr('data-autoplay');
        let slideAutoPlay = slideAuto == 'true' ? true : false;
        $imageSlider.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            arrows: false,
            autoplay: slideAutoPlay,
            autoplaySpeed: slideSpeed,
            dots : true
        });
    }


    // BLOG TAB
    $('.section-event .event-tab li a').click(function() {
        let tab_id = $(this).attr('data-tab');
        let $sectionBlogs = $(this).closest('.section-event');
        $sectionBlogs.find('.event-tab li').removeClass('active');
        $(this).parent().addClass('active');
        $sectionBlogs.find('.blog-tab-contents .wrap-tab').hide();
        if( $(tab_id).length > 0 ) {
            $(tab_id).stop().fadeIn(300);
        }
    });


    // BRAND ACTIVE
    $('.section-brand .brand-info .brand-logo a, .section-brand .brand-info .brand-product').hover(function(){
        $(this).closest('.brand-info').addClass('show-products');
    }, function() {
        $(this).closest('.brand-info').removeClass('show-products');
    });


    // BRAND PRODUCT SLIDER
    if ( $(window).width() <= 768 ) {
        $('.brand-product .product-wrap').slick({
            autoplay: true,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 1000,
            arrows: true
        });
    };


    // LPC HOT PRODUCT SLIDE
    $('.lpc-product-thumb-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });


    // YOUTUBE LIST SLIDER
    $('.listYoutube').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });


    // MAIN SLIDER
    $('.mainSlider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchMove: false,
        dots: true
    });


    // SLIDE PRODUCT INTO CONTENT
    $('.sliderContain').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true
    });


    // TEXT MORE ACTION
    $('.textMoreBox .textMoreBtn').click(function(){
        let $moreBox = $(this).closest('.textMoreBox');
        let moreText = $(this).data('more-text');
        let lessText = $(this).data('less-text');
        if( $moreBox.hasClass('fulltext') ) {
            $(this).text(moreText);
            $moreBox.removeClass('fulltext');
        } else {
            $(this).text(lessText);
            $moreBox.addClass('fulltext');
        }
    });


});
})(jQuery);